<script setup>
import { toRefs, toRef } from 'vue'
import { useErrorMessage } from '@/studentsite/common/useErrorMessage'
import { useDepartmentSelection } from './useDepartmentSelection'

/**
 * @import { PropType } from 'vue'
 * @import { Emits } from './emitTypes'
 * @import { Department } from '../Suggest/useDepartmentList'
 * @import { ComponentProps } from '../../../propTypes'
 */

const props = defineProps({
  default: {
    type: String,
    default: '',
  },
  isAbroad: {
    type: Boolean,
    default: false,
  },
  departmentList: {
    /** @type {PropType<Array<Department>>} */
    type: Array,
    required: true,
  },
  inputErrors: {
    /** @type {PropType<ComponentProps["inputErrors"]>} */
    type: Object,
    required: true,
  },
  validationErrors: {
    /** @type {PropType<string[]>} */
    type: Object,
    required: true,
  },
})
const { has: errorHas } = useErrorMessage(toRef(() => props.inputErrors).value)
/** @type {Emits<Array<Department>>} */
const emits = defineEmits(['inputChange', 'selectionChange', 'textChange'])

const reactiveProps = toRefs(props)
const {
  value,
  departmentList: itemList,
  openSuggestions,
  onClickOption,
  onFocusEvent,
  onInput,
  clearValue,
  onChange,
} = useDepartmentSelection(props.default, reactiveProps.departmentList, emits)

defineExpose({ clearValue })
</script>

<template>
  <input
    type="text"
    name="faculty"
    placeholder="例 ）経済学部、理工学研究科"
    class="form--line form--w100 js_suggestOpen js_dataInput"
    :class="{ md_error: errorHas('faculty_cd') || errorHas('faculty') || validationErrors.length }"
    :value="value"
    autocomplete="off"
    @focus="onFocusEvent(true, props.isAbroad)"
    @blur="onFocusEvent(false, props.isAbroad)"
    @input="onInput"
    @change="onChange"
  />
  <ul
    v-show="openSuggestions"
    class="md_list md_list--suggest"
  >
    <li
      v-for="item in itemList"
      :key="`university_department_suggestions_${item.cd}`"
      class="row"
      @mousedown="onClickOption(item)"
    >
      <button
        type="button"
        class="list js_suggestInput js_suggestX"
      >
        <div class="txtCell">
          <div class="txtSet">
            <div
              class="main"
              v-text="item.text"
            />
          </div>
        </div>
      </button>
    </li>
  </ul>
</template>
